/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-08-22 22:03:06
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\logistics\logisticsquery\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';

import { getOrderAddressPageList, getorderInfo, orderLabel, updateOrder, orderCancel, getAddLogistics, orderBatchLabel, orderBatchCancel, getEventCodeList, downLabels } from './service'
import { TableDataType, TableListQueryParams, OrderInfoParams, OrderInfoTableDataType, LabelResType, updateOrderType, addLogisticsType, SeeLogisticeTypeList, orderBatchLabelType, BatchLabelType, getEventCodeListType } from './data.d'

export interface StateType {
    errorMsg?: string;
    tableData: TableDataType;
    orderInfo: OrderInfoTableDataType;
    labelInfo: LabelResType;
    seeLogistice: SeeLogisticeTypeList;
    batchLabelDataList: BatchLabelType;
    orderBatchListData: any;
    gwosEventCodeData: any;
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getOrderList: Mutation<StateType>;
        getOrderInfo: Mutation<StateType>;
        getLabelInfo: Mutation<StateType>;
        seeLogisticeData: Mutation<StateType>;
        batchLabelData: Mutation<StateType>;
        orderBatchList: Mutation<StateType>;
        gwosEventCodeList: Mutation<StateType>;
    };
    actions: {
        getOrderAddressPageListFn: Action<StateType, StateType>;
        getorderInfoFn: Action<StateType, StateType>;
        getorderLabelFn: Action<StateType, StateType>;
        updateOrderFn: Action<StateType, StateType>;
        orderCancelFn: Action<StateType, StateType>;
        seeLogisticeFn: Action<StateType, StateType>;
        orderBatchLabelFn: Action<StateType, StateType>;
        orderBatchCancelFn: Action<StateType, StateType>;
        gwosEventCodeFn: Action<StateType, StateType>;
        downLabelsFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    tableData: {
        orderlist: [],
        pagination: {
            total: 0,
            showTotal: "",
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        },
    },
    orderInfo: {
        actualWeight: 0,
        addresseeAddess: {
            addressType: 0,
            city: '',
            company: '',
            countryCn: '',
            countryCode2: '',
            countryEn: '',
            createdAt: '',
            detailedAddress1: '',
            detailedAddress2: '',
            detailedAddress3: '',
            email: '',
            id: 0,
            mobilePhone: '',
            province: '',
            region: '',
            street: '',
            telephone: '',
            updatedAt: '',
            userName: '',
            zipCode: '',
        },
        addresseeAddessId: 0,
        amount: 0,
        createdAt: '',
        deliveryNo: '',
        destination: '',
        eventCode: '',
        gwtNo: '',
        height: 0,
        id: 0,
        length: 0,
        logisticsNo: '',
        orderDate: '',
        orderSkuList: [],
        orderSource: 0,
        orderWeight: 0,
        orderEventList: [],
        senderAddess: {
            addressType: 0,
            city: '',
            company: '',
            countryCn: '',
            countryCode2: '',
            countryEn: '',
            createdAt: '',
            detailedAddress1: '',
            detailedAddress2: '',
            detailedAddress3: '',
            email: '',
            id: 0,
            mobilePhone: '',
            province: '',
            region: '',
            street: '',
            telephone: '',
            updatedAt: '',
            userName: '',
            zipCode: '',
        },
        senderAddessId: 0,
        status: 0,
        taxNo: '',
        transactionNo: '',
        transportationDate: '',
        updatedAt: '',
        userCode: '',
        width: 0,
        userAddress: {}
    },
    labelInfo: {
        imgFileId: null,
        pdfFileId: null,
    },
    seeLogistice: {
        list: []
    },
    batchLabelDataList: {
        labelBase64: '',
        gwtNos: []
    },
    orderBatchListData: {},
    gwosEventCodeData: {}
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'logisticsquery',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getOrderList(state, payload) {
            state.tableData = payload
        },
        getOrderInfo(state, payload) {
            state.orderInfo = payload
        },
        getLabelInfo(state, payload) {
            state.labelInfo = payload
        },
        seeLogisticeData(state, payload) {
            state.seeLogistice.list = payload
        },
        batchLabelData(state, payload) {
            state.batchLabelDataList = payload
        },
        orderBatchList(state, payload) {
            state.orderBatchListData = payload
        },
        gwosEventCodeList(state, payload) {
            state.gwosEventCodeData = payload
        },
    },
    actions: {
        //获取物流列表信息
        async getOrderAddressPageListFn({ commit }, params: TableListQueryParams) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await getOrderAddressPageList(params)
                const { body } = req
                const data = body?.datas
                const countrylistSet = JSON.parse(String(localStorage.getItem('person')))
                data.map((s: any) => {
                    countrylistSet.map((item: any) => {
                        if (item.code == s.destination) {
                            s.destination = item.name
                        }
                    })
                })
                commit('getOrderList', {
                    ...initState.tableData,
                    orderlist: data || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0,
                        showTotal: ((total) => {
                            return `共 ${total} 条`;
                        }),
                    }
                })
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //获取物流详情
        async getorderInfoFn({ commit }, params: OrderInfoParams) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await getorderInfo(params)
                const { body } = req
                const countrylistSet = JSON.parse(String(localStorage.getItem('person')))
                countrylistSet.map((item: any) => {
                    if (item.code == body.destination) {
                        body.destination = item.name
                    }
                })
                body.orderEventList.filter((item:any)=> {
                    if(item.display){
                        return item
                    }
                })
                console.log('body.orderEventList',body.orderEventList)
                commit('getOrderInfo', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //获取面单
        async getorderLabelFn({ commit }, params: any) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await orderLabel(params)
                const { body } = req
                commit('getLabelInfo', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //订单修改
        async updateOrderFn({ commit }, params: updateOrderType) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await updateOrder(params)
                const { body } = req
                commit('updateOrderInfo', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //订单取消
        async orderCancelFn({ commit }, params: updateOrderType) {
            let msg: string | undefined = undefined
            try {
                await orderCancel(params)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //查看物流轨迹
        async seeLogisticeFn({ commit }, params: addLogisticsType) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await getAddLogistics(params)
                const { body } = req
                const data = body.filter((item:any) => {
                    if(item.display){
                        return item
                    }
                })
                console.log(data)
                commit('seeLogisticeData', data)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //批量打印面单
        async orderBatchLabelFn({ commit }, params: orderBatchLabelType) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await orderBatchLabel(params)
                const { body } = req
                commit('batchLabelData', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //批量取消订单
        async orderBatchCancelFn({ commit }, params: orderBatchLabelType) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await orderBatchCancel(params)
                const { body } = req
                commit('orderBatchList', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //查询Gwos_Event_Code列表
        async gwosEventCodeFn({ commit }, params: getEventCodeListType) {
            let msg: string | undefined = undefined
            try {
                const req: ResponseData = await getEventCodeList(params)
                const { body } = req
                commit('gwosEventCodeList', body)
                msg = '';
            } catch (error: any) {
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg', msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //批量下载面单
        async downLabelsFn({commit}, params:updateOrderType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await downLabels(params)
                const { body } = req
                return body
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

    }
}

export default StoreModel
